var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.68685 4.60419L5.18164 4.02606L4.02539 5.18231L4.60352 7.68752L2.29102 9.22919V10.7709L4.60352 12.3125L4.02539 14.8177L5.18164 15.974L7.68685 15.3959L9.22852 17.7084H10.7702L12.3118 15.3959L14.8171 15.974L15.9733 14.8177L15.3952 12.3125L17.7077 10.7709V9.22919L15.3952 7.68752L15.9733 5.18231L14.8171 4.02606L12.3118 4.60419L10.7702 2.29169H9.22852L7.68685 4.60419Z",
    stroke: "#6B8299",
    strokeOpacity: 0.8,
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.291 10C12.291 11.2657 11.265 12.2917 9.99935 12.2917C8.7337 12.2917 7.70768 11.2657 7.70768 10C7.70768 8.73437 8.7337 7.70835 9.99935 7.70835C11.265 7.70835 12.291 8.73437 12.291 10Z",
    stroke: "#6B8299",
    strokeOpacity: 0.8,
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.103c84d6bb6eef5d3ed99fe6dd06a657.svg";
export { ForwardRef as ReactComponent };